/**
 * Shared display config for the SA-284 department-gate lane
 * (`order_department_gates.state`). Lives in its own module — mirrors
 * queueStates.ts — because more than one surface renders these (QueuePanel's
 * Gates section, plus the inbox sidebar's worst-gate badge).
 */

import type { GateState } from '@/types/commerce'

export const GATE_STATE_CONFIG: Record<GateState, { label: string; className: string }> = {
  not_required: {
    label: 'Not required',
    className: 'bg-muted text-muted-foreground',
  },
  auto_checked: {
    label: 'Auto-checked',
    className: 'bg-sky-100 text-sky-700',
  },
  pass: {
    label: 'Pass',
    className: 'bg-success/10 text-success',
  },
  conditional: {
    label: 'Conditional',
    className: 'bg-amber-100 text-amber-700',
  },
  review_required: {
    label: 'Review required',
    className: 'bg-purple-100 text-purple-700',
  },
  unverified: {
    label: 'Unverified',
    className: 'bg-orange-100 text-orange-700',
  },
  not_acceptable: {
    label: 'Not acceptable',
    className: 'bg-destructive/10 text-destructive',
  },
}

// Mirrors backend `department_gates.STAFF_SETTABLE` (spec §6): every gate
// state except `auto_checked`, which is rule-evaluation-only and never a
// manual-endpoint target. Order matches `department_gates.GATE_STATES`.
export const STAFF_SETTABLE_GATE_STATES: GateState[] = [
  'not_required',
  'pass',
  'conditional',
  'review_required',
  'unverified',
  'not_acceptable',
]
